export type AuthMode = 'msal' | 'mock';

export interface AppConfig {
  apiBaseUrl: string;
  wsUrl: string;
  authMode: AuthMode;
  entraClientId: string;
  entraTenantId: string;
  apiScope: string;
  redirectUri: string;
  entorn: string;
}

function derivaWsUrl(apiBaseUrl: string): string {
  const base = apiBaseUrl.replace(/\/api\/v1\/?$/, '');
  if (base.startsWith('https://')) return `wss://${base.slice(8)}/ws`;
  if (base.startsWith('http://')) return `ws://${base.slice(7)}/ws`;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  return `${origin.replace(/^http/, 'ws')}${base}/ws`;
}

export function llegeixConfig(env: ImportMetaEnv = import.meta.env): AppConfig {
  const apiBaseUrl = (env.VITE_API_BASE_URL ?? '/api/v1').replace(/\/$/, '');
  const authMode: AuthMode = env.VITE_AUTH_MODE === 'mock' ? 'mock' : 'msal';
  return {
    apiBaseUrl,
    wsUrl: env.VITE_WS_URL ?? derivaWsUrl(apiBaseUrl),
    authMode,
    entraClientId: env.VITE_ENTRA_CLIENT_ID ?? '',
    entraTenantId: env.VITE_ENTRA_TENANT_ID ?? '',
    apiScope: env.VITE_API_SCOPE ?? '',
    redirectUri:
      env.VITE_REDIRECT_URI ?? (typeof window !== 'undefined' ? window.location.origin : ''),
    entorn: env.VITE_ENTORN ?? 'Producció',
  };
}

export const config: AppConfig = llegeixConfig();
